














































































import { Component, Vue, Watch } from "vue-property-decorator";
import headerTitle from "@/components/header.vue";
import { BoxPayGrade, CheckUser } from "@/req/pay";
import qrCode from "./Qrcode/index.vue";
@Component({
  components: {
    headerTitle,
    qrCode
  },
})
export default class Home extends Vue {
  public account = "";
  // public accountStatus = false;
  public lastAccount = "";
  public payGradeData: any = [];
  public otherMoney = "";
  public inputStatus = false;
  public numStatus = false;
  // 支付方式
  public payWay = [
    {
      pay_id: 0,
      name: "支付宝",
    },
    {
      pay_id: 1,
      name: "微信",
    },
  ];
  public boxName = {
    payMoney: "",
    uid: "",
    activeWay: null,
    activeCredit: null,
    accountStatus: false
  };
  public timeID: any = null;
  public ms = 500;
  public qrCodeStatus = false;
  @Watch("qrCodeState", { immediate: true, deep: true })
  public boxNameChange(newL, oldL) {
    if (newL !== oldL) {
      this.ms = 500;
      clearTimeout(this.timeID);
      this.timeID = setTimeout(() => {
        this.qrCodeStatus = newL;
      }, this.ms);
    }
  }
  get qrCodeState() {
    return (
      this.boxName.activeWay != null &&
      this.boxName.payMoney != "" &&
      this.boxName.accountStatus == true &&
      this.account != ""
    );
  }
  public created() {
    this.account = this.lastAccount = JSON.parse(
      JSON.stringify(this.$store.state.user.info.account)
    );
    this.payGrade();
  }
  public mounted() {
    this.judge();
  }
  // 用户信息判断
  public async judge() {
    const res = await CheckUser({
      token: this.$fn.cookies.getToken("token"),
      account: this.account,
    });
    if (res.code == 200) {
      this.boxName.uid = res.data.role_info.id;
      this.lastAccount = this.account;
      this.boxName.accountStatus = true
    } else {
      this.boxName.accountStatus = false;
      this.$Message.error(res.msg);
    }
  }
  // 获取币种数值
  public async payGrade() {
    const res = await BoxPayGrade({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code === 200) {
      this.payGradeData = res.data.pay_grade;
    }
  }
  // 充值货币转换
  public payCredit(index, money) {
    this.otherMoney = this.boxName.payMoney = "";
    this.inputStatus = false;
    this.numStatus = false;
    this.boxName.accountStatus = false;
    if (this.boxName.activeCredit == index) {
      this.boxName.payMoney = "";
      this.boxName.activeCredit = null;
    } else {
      this.boxName.activeCredit = index;
      this.boxName.payMoney = money + "";
      this.boxName.accountStatus = true;
    }
  }
  // 获取输入数量
  public otherChange() {
    this.boxName.activeCredit = null;
    this.boxName.payMoney = this.otherMoney;
  }
  // 正则校验
  public clearBlank() {
    this.otherMoney = this.otherMoney
      .replace(/[^\d]/g, "")
      .replace(/^0{1,}/g, "");
  }
  // 支付状态判断
  public paycomWay(index) {
    if (this.boxName.activeWay == index) {
      this.boxName.activeWay = null;
    } else {
      this.boxName.activeWay = index;
    }
  }
  // 判断是否输入值
  public blurChange() {
    if (this.otherMoney == "" && this.boxName.activeCredit == null) {
      this.inputStatus = true;
      this.numStatus = false;
    } else {
      this.inputStatus = false;
      this.numStatus = true;
      this.boxName.accountStatus = true;
    }
  }
  public foucsChange() {
    this.boxName.accountStatus = false;
    if (this.otherMoney == "") {
      this.boxName.payMoney = "";
    }
    this.boxName.activeCredit = null;
    if (!this.numStatus) {
      this.numStatus = true;
    }
  }
}
